<!--
 * @Author: 魑魅魍魉鬼魃魈
 * @Date: 2021-10-22 15:32:46
 * @LastEditTime: 2022-01-18 14:34:21
 * @Description: 描述
-->
<template>
  <div class="home-container">
    <DetailHead />
    <HomeHead />
    <!-- <music-player></music-player> -->
    <ProdDesc />
    <!-- <ProdImg /> -->
    <!-- <template v-for="item in messageData">
      <home-message
        :title="item.channel_name"
        :dataList="item.list"
        :key="item.channel_name"
        :total="item.game_count"
        :id="item.channel_id"
      />
    </template> -->
    <HomeFooter />
  </div>
</template>

<script>
import HomeHead from './components/HomeHead'
import HomeFooter from './components/HomeFooter'
import ProdDesc from './components/ProdDesc'
// import ProdImg from './components/ProdImg'
import DetailHead from '../detail/components/DetailHead'
// import MusicPlayer from '../player'
// import HomeMessage from './components/HomeMessage.vue'

import { mapState } from 'vuex'

export default {
  name: 'Home',
  components: {
    HomeHead,
    HomeFooter,
    ProdDesc,
    // ProdImg,
    DetailHead,
    // MusicPlayer,
    // HomeMessage
  },
  computed: {
    ...mapState([])
  },
  data() {
    return {
      messageData: [],
      items: [
        {
          laneType: 105,
          channel_id: 'NT',
          channel_name: '最近更新',
          list: [],
          game_count: 0,
          page: 1,
          pageSize: 10,
          totalPages: 0,
          init: 1
        },
        {
          laneType: 101,
          channel_id: 'NT',
          channel_name: '新作首秀',
          list: [],
          game_count: 0,
          page: 1,
          pageSize: 10,
          totalPages: 0,
          init: 3
        }
      ]
    }
  },
  async created() {
    await this.getData()
  },
  methods: {
    async getEditNT(i) {
      if (i) {
        const { isOk, data } = await this.$api.getEditNT(i)
        if (isOk) {
          return { ...i, list: [...data], game_count: data.length }
        }
      }
      return null
    },
    async getData(page = 1) {
      const {
        isOk,
        data: { game_data, total_pages }
      } = await this.$api.getEditPageData({
        sortType: 0, //(筛选条件:0推荐,1新晋)
        type: 10, //type大于0（同ios端传值）则返回数组，否则是对象，getEditPageData方法对应接口用
        page,
        pageSize: 4
      })
      if (isOk) {
        const detail = this.items[page - 1]
        const data = await this.getEditNT(detail)
        if (data) {
          game_data.splice(detail.init, 0, data)
        }
        const messageData = [...this.messageData, ...game_data]
        this.messageData = messageData.filter(i => i && i.list && i.list.length > 0)
        total_pages > page && this.getData(page + 1)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.home-container {
  min-width: @gb_minWidth;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
    '微软雅黑', Arial, sans-serif;
}
</style>
